<template>
    <div>
        <form @submit.prevent="onSubmit" @keydown="forgetErrorsFor($event.target.name)">
            <div class="mb-4">
                <h4 class="mt-0 mb-1">{{ $t('updates.general_details') }}</h4>
                <p class="mb-0">{{ $t('updates.general_details_info') }}</p>
            </div>
            <div class="lg:w-5/6 w-full mb-3">
                <div class="lg:w-3/4 mb-3" :class="{ 'has-error': form.errors.has('application_id') }">
                    <label class="mb-1" for="application_id">{{ $t('globals.application') }}</label>
                    <select class="custom-select" id="application_id" name="application_id" v-model="form.application_id" @change="form.errors.forget($event.target.name)">
                        <option v-for="application in applications" :value="application.id">{{ application.name }}</option>
                    </select>
                    <p class="help-block" v-if="form.errors.has('application_id')" v-text="form.errors.get('application_id')"></p>
                </div>
                <div class="lg:w-3/4 mb-3" :class="{ 'has-error': form.errors.has('type') }">
                    <label class="mb-1" for="type">{{ $t('globals.type') }}</label>
                    <select class="custom-select" id="type" name="type" v-model="form.type" @change="form.errors.forget($event.target.name)">
                        <option v-for="(updateType, key) in updateTypes" :value="key">{{ updateType }}</option>
                    </select>
                    <p class="help-block" v-if="form.errors.has('type')" v-text="form.errors.get('type')"></p>
                </div>
            </div>
            <div class="mt-10 mb-4">
                <h4 class="my-0">{{ $t('updates.content') }}</h4>
            </div>
            <div class="lg:w-5/6 w-full">
                <div class="mb-3" v-for="(content, contentKey) in form.contents">
                    <label :for="`content_for_${content.locale}`" class="mb-1">{{ $t('updates.language', { value: languages[content.locale].toLowerCase() }) }}</label>
                    <div :class="{ 'has-error': ((form.errors.has('contents') && contentKey === 0) || form.errors.has(`contents.${contentKey}.locale`)) }">
                        <div class="mb-3" :class="{ 'has-error': form.errors.has(`contents.${contentKey}.title`) }">
                            <input class="form-control" :id="`contents.${contentKey}.title`" :name="`contents.${contentKey}.title`" type="text" :placeholder="$t('updates.title')" v-model="form.contents[contentKey].title" />
                            <p class="help-block text-danger-500" v-if="form.errors.has(`contents.${contentKey}.title`)" v-text="form.errors.get(`contents.${contentKey}.title`)"></p>
                        </div>
                        <div :class="{ 'has-error': form.errors.has(`contents.${contentKey}.content`) }">
                            <!--
                            <tiptap
                                v-model="form.contents[contentKey].content"
                                :placeholder="$t('updates.content_placeholder')">
                            </tiptap>
                            -->
                            <textarea class="form-control" :id="`contents.${contentKey}.content`" :name="`contents.${contentKey}.content`" :placeholder="$t('updates.content_placeholder')" rows="4" v-model="form.contents[contentKey].content"></textarea>
                            <p class="help-block text-danger-500" v-if="form.errors.has(`contents.${contentKey}.content`)" v-text="form.errors.get(`contents.${contentKey}.content`)"></p>
                        </div>
                        <template v-if="contentKey === 0">
                            <p class="help-block text-danger-500" v-if="form.errors.has('contents')" v-text="form.errors.get('contents')"></p>
                            <p class="help-block text-danger-500" v-else-if="form.errors.has(`contents.${contentKey}.locale`)" v-text="form.errors.get(`contents.${contentKey}.locale`)"></p>
                        </template>
                        <template v-else>
                            <p class="help-block text-danger-500" v-if="form.errors.has(`contents.${contentKey}.locale`)" v-text="form.errors.get(`contents.${contentKey}.locale`)"></p>
                        </template>
                    </div>
                </div>
            </div>
            <div class="pt-2">
                <button class="btn btn-primary" :disabled="form.errors.any()" type="submit">
                    {{ $t('globals.save_changes') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import Tiptap from '../../shared/tiptap.vue';

export default {
    components: {
        'tiptap': Tiptap,
    },

    props: {
        applications: {
            type: Array,
            required: true,
        },
        updateTypes: {
            type: Object,
            required: true,
        },
        languages: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            form: new Form({
                application_id: null,
                type: null,
                contents: [],
            }),
        };
    },

    created() {
        this.addContentsToForm();
    },

    methods: {
        addContentsToForm() {
            this.form.contents = Object.keys(this.languages).map(language => ({
                locale: language,
                title: '',
                content: '',
            }));
        },

        forgetErrorsFor(targetName) {
            if (targetName.startsWith('contents.')) {
                this.form.errors.forget('contents');
                if (targetName.includes('content')) {
                    this.form.errors.forget(targetName.replace('content', 'locale'));
                }
                if (targetName.includes('title')) {
                    this.form.errors.forget(targetName.replace('title', 'locale'));
                }
            }
            this.form.errors.forget(targetName);
        },

        onSubmit() {
            Globals.post('/kiosk/updates', this.form)
                .then(() => {
                    const flash = {
                        type: 'success',
                        message: this.$t('updates.added'),
                    };
                    window.sessionStorage.setItem('flash', JSON.stringify(flash));
                })
                .then(() => window.location.href = '/kiosk/updates')
                .catch(error => {
                    if (error.message !== 'The given data was invalid.') {
                        window.toastr.clear();
                        window.toastr.error(this.$t('globals.unexpected_error'));
                    }
                });
        },
    },
};
</script>
